import { validateFeature } from 'helpers/featuresHelpers';
import { getActivityValue } from 'modules/activities-management';

export const mainValidator = properties => {
  const {
    features,
    activities,
    activityTypes,
  } = properties;

  const validators = {};

  activities.forEach(activity => {
    // Have at least one date
    validators[`properties.activities.${activity.uid}.eventDates`] = () => !!activity.eventDates.length;

    // Have feature(s)
    validators[`properties.activities.${activity.uid}.features`] = () => {
      const [, type] = activity.type.split(/,/);
      const schema = getActivityValue(activityTypes, type) || { controls: [] };
      const hasMap = schema.controls.find(control => control.name === 'location');

      return !hasMap || validateFeature(features, activity);
    };
  });

  return validators;
};

export default mainValidator;



// WEBPACK FOOTER //
// ./src/components/Form/validators.js